
// FORMATO DOS DADOS RECEBIDOS
// {
//     "estudante": 833,
//         "competencias": [
//             {
//                 "id": 188,
//                 "disciplina": 2,
//                 "competenciaNome": "Identificar os principais conflitos geopolíticos, para examinar seus contextos geográficos sobre a compreensão do espaço mundial.",
//                 "notas": [
//                     {
//                         "tipoCriterio": 5,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 3,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 1,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 2,
//                         "nota": 60
//                     },
//                     {
//                         "tipoCriterio": 6,
//                         "nota": 60
//                     }
//                 ]
//             },
//             {
//                 "id": 187,
//                 "disciplina": 1,
//                 "competenciaNome": "Analisar e comparar as principais teorias da filosofia da mente para avaliar suas contribuições e limitações no entendimento da relação entre mente e corpo, e a aplicabilidade dessas teorias na inteligência artificial e na compreensão da consciência.",
//                 "notas": [
//                     {
//                         "tipoCriterio": 6,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 1,
//                         "nota": 60
//                     },
//                     {
//                         "tipoCriterio": 2,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 5,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 1,
//                         "nota": 90
//                     },
//                     {
//                         "tipoCriterio": 1,
//                         "nota": 60
//                     }
//                 ]
//             },
//             {
//                 "id": 113,
//                 "disciplina": 3,
//                 "competenciaNome": "Identificar os diferentes tipos de blocos econômicos dentro do contexto de Guerra Fria",
//                 "notas": [
//                     {
//                         "tipoCriterio": 5,
//                         "nota": 60
//                     },
//                     {
//                         "tipoCriterio": 2,
//                         "nota": 1
//                     },
//                     {
//                         "tipoCriterio": 1,
//                         "nota": 1
//                     }
//                 ]
//             }
//         ]
// }
export default function calcularMediaPorAlunoPorCompetencia(estudante) {

    const desempenhoPorCompetencia = []
    
    estudante.competencias.forEach((competencia) => {
        let somaPonderadaNotas = 0;
        let somaPesos = 0;

        competencia.notas.forEach((item)=> {
            if (item.nota > 0 && item.nota <= 200) {
                let peso = (item.tipoCriterio === 1 || item.tipoCriterio === 2 || item.tipoCriterio === 3 || item.tipo === "2") ? 3 : 0.5;
                let nota = item.nota;
                if (nota === 1) {
                    nota = nota * 40;
                }
                if (nota == 10) {
                    nota = nota * 4;
                }
                somaPonderadaNotas += nota * peso;
                somaPesos += peso;
            } 
        })

        let resultado;

        if (somaPesos === 0) {
            resultado = 0; 
        }else{
           resultado = Math.round(somaPonderadaNotas / somaPesos)
        }

        desempenhoPorCompetencia.push({ id: competencia.id, disciplina: competencia.disciplina, desempenho: resultado, competencia: competencia.competenciaNome })
    })

    return desempenhoPorCompetencia;

}